import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import theme from 'styled-theming';
import { StatefulToolTip } from 'react-portal-tooltip';
import { ReactComponent as IconInfo } from '../assets/icon-info.svg';

const color = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const tooltipColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.black,
});

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.lavenderGrey,
  dark: (props) => props.theme.colors.pastelBlue,
});

const shadow = theme('mode', {
  light: (props) => props.theme.shadows.small,
  dark: (props) => props.theme.shadows.small,
});

const InfoImage = styled(IconInfo)`
  margin-left: 5px;
  vertical-align: middle;
  color: ${color};
`;

const Icon = (
  <InfoImage width="12" height="12" mr={2} ml={2} />
);

function Info(props) {
  const {
    tooltip,
  } = props;

  const tooltipStyle = {
    style: {
      background: backgroundColor(props),
      color: tooltipColor(props),
      boxShadow: shadow(props),
      padding: '16px',
      fontSize: '12px',
      lineHeight: '16px',
      transition: 'none',
      maxWidth: '170px',
    },
    arrowStyle: {
      color: backgroundColor(props),
      borderColor: false,
    },
  };

  if (!tooltip) {
    return null;
  }

  return (
    <StatefulToolTip
      parent={Icon}
      position="top"
      arrow="center"
      className="stateful-button"
      style={tooltipStyle}
    >
      {tooltip}
    </StatefulToolTip>
  );
}

Info.propTypes = {
  tooltip: PropTypes.string.isRequired,
};

export default withTheme(Info);
